import React from "react";
import {Button, Form, InputGroup} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import i18next from "../../../i18n"

const PublicationsSearchField = ({ onSearch }) => {

    const [searchTerm, setSearchTerm] = React.useState("");

    const searchTermChanged = (event) => {
        setSearchTerm(event.target.value);
    }

    return (
        <div>
                <InputGroup className={"search-form"}>
                    <Form.Control
                        className={""}
                        placeholder={i18next.t('publications.search', 'Search')} onChange={searchTermChanged} />
                    <span id="publications-search-btn" className={"btn-primary-g clickable-item"} onClick={() => onSearch(searchTerm)}>{i18next.t('publications.search', 'Search')}</span>
                </InputGroup>
        </div>
    );
}

export default PublicationsSearchField;
